export default __webpack_public_path__ + "static/media/PositiveRunningToeOff.111b6688.png";